import { SelectOption } from '@globaleris/ui.library'
import { ContractProductAPIModel } from '../../api/Pioneer/model/Contracts'
import i18n from '../../i18n'
import {
  fetchClient,
  fetchCountries,
  fetchMunicipalities,
  fetchProvinces
} from '../../pages/clients/client.service'
import { ClientFileModel } from '../../pages/clients/clients.model'
import { clientDataMapper } from '../../pages/clients/file/client.file.mapper'
import { NewContractProduct } from '../../pages/contracts/contracts.model'
import {
  fetchContractByID,
  fetchContractsBySubjectID,
  fetchProductsByContractID
} from '../../pages/contracts/contracts.service'
import { notifyError } from '../helpers'
import { ContractModel } from '../../api/Argentia/model/contracts'
import { CommercialModel } from '../../api/Argentia/model/commercials/commercial'
import { fetchCommercialsBySubjectID } from '../../pages/commercial/commercials/commercials.service'
import { FlexibilitiesModel } from '../../api/Argentia/endpoints/flexibilities/model/flexibilities'
import { MunicipalityModel, ProvinceModel } from '../../api/Argentia/model/addresses'
import { store } from '../store'

export enum ClientsActionTypes {
  FETCH_COUNTRIES_START = 'FETCH_COUNTRIES_START',
  FETCH_COUNTRIES_END = 'FETCH_COUNTRIES_END',
  FETCH_COUNTRIES_ERROR = 'FETCH_COUNTRIES_ERROR',
  FETCH_PROVINCES_START = 'FETCH_PROVINCES_START',
  FETCH_PROVINCES_END = 'FETCH_PROVINCES_END',
  FETCH_PROVINCES_ERROR = 'FETCH_PROVINCES_ERROR',
  FETCH_MUNICIPALITIES_START = 'FETCH_MUNICIPALITIES_START',
  FETCH_MUNICIPALITIES_END = 'FETCH_MUNICIPALITIES_END',
  FETCH_MUNICIPALITIES_ERROR = 'FETCH_MUNICIPALITIES_ERROR',
  FETCH_CONTRACT_START = 'FETCH_CONTRACT_START',
  FETCH_CONTRACT_END = 'FETCH_CONTRACT_END',
  FETCH_CONTRACT_ERROR = 'FETCH_CONTRACT_ERROR',
  FETCH_CONTRACT_PRODUCTS_START = 'FETCH_CONTRACT_PRODUCTS_START',
  FETCH_CONTRACT_PRODUCTS_END = 'FETCH_CONTRACT_PRODUCTS_END',
  FETCH_CONTRACT_PRODUCTS_ERROR = 'FETCH_CONTRACT_PRODUCTS_ERROR',
  FETCH_CONTRACTS_START = 'FETCH_CONTRACTS_START',
  FETCH_CONTRACTS_END = 'FETCH_CONTRACTS_END',
  FETCH_CONTRACTS_ERROR = 'FETCH_CONTRACTS_ERROR',
  FETCH_COMMERCIALS_START = 'FETCH_COMMERCIALS_START',
  FETCH_COMMERCIALS_END = 'FETCH_COMMERCIALS_END',
  FETCH_COMMERCIALS_ERROR = 'FETCH_COMMERCIALS_ERROR',
  FETCH_CLIENT_START = 'FETCH_CLIENT_START',
  FETCH_CLIENT_END = 'FETCH_CLIENT_END',
  FETCH_CLIENT_ERROR = 'FETCH_CLIENT_ERROR',
  STORE_SEARCH_TEXT = 'STORE_SEARCH_TEXT',
  STORE_CLIENT_DATA = 'STORE_CLIENT_DATA',
  STORE_CLIENT_CONTRACTS = 'STORE_CONTRACTS',
  STORE_CLIENT_COMMERCIALS = 'STORE_COMMERCIALS',
  STORE_CONTRACT_PRODUCTS = 'STORE_CONTRACT_PRODUCTS',
  STORE_ACTIVE_CONTRACT = 'STORE_ACTIVE_CONTRACT',
  STORE_ACTIVE_FLEXIBILITY = 'STORE_ACTIVE_FLEXIBILITY',
  CLEAR_ACTIVE_FLEXIBILITY = 'CLEAR_ACTIVE_FLEXIBILITY',
  CLEAR_ACTIVE_CONTRACT = 'CLEAR_ACTIVE_CONTRACT',
  TEMP_ADD_CONTRACT_PRODUCT = 'TEMP_ADD_CONTRACT_PRODUCT',
  TEMP_UPDATE_CONTRACT_PRODUCT = 'TEMP_UPDATE_CONTRACT_PRODUCT',
  TEMP_REMOVE_CONTRACT_PRODUCT = 'TEMP_REMOVE_CONTRACT_PRODUCT',
  STORE_COUNTRIES = 'STORE_COUNTRIES',
  STORE_PROVINCES = 'STORE_PROVINCES',
  STORE_MUNICIPALITIES = 'STORE_MUNICIPALITIES',
  STORE_CLIENT_CONTRACT = 'STORE_CLIENT_CONTRACT',
  UPDATE_CLIENT_CONTRACT = 'UPDATE_CLIENT_CONTRACT',
  SET_ACTIVE_CONTRACT = 'SET_ACTIVE_CONTRACT',
  SET_DESACTIVE_CONTRACT = 'SET_DESACTIVE_CONTRACT',
  CLEAR_CLIENT_DATA = 'CLEAR_CLIENT_DATA',
  CLEAR_CLIENT_CONTRACTS = 'CLEAR_CLIENT_CONTRACTS',
  CLEAR_CLIENT_COMMERCIALS = 'CLEAR_CLIENT_COMMERCIALS',
  REMOVE_CLIENT_CONTRACT = 'CLEAR_CLIENT_CONTRACT',
  SWITCH_COMM_CLIENT_FILE_OFF = 'SWITCH_COMM_CLIENT_FILE_OFF',
  SWITCH_COMM_CLIENT_ADD_OFF = 'SWITCH_COMM_CLIENT_ADD_OFF',
  ACTIVE_TAB_ADITIONALS = 'ACTIVE_TAB_ADITIONALS'
}

export interface StoreSearchTextAction {
  type: ClientsActionTypes
  payload: string
}

export interface StoreVersionsAction {
  type: ClientsActionTypes
  payload: boolean
}

export interface StoreClientDataAction {
  type: ClientsActionTypes
  payload: ClientFileModel
}

export interface StoreC {
  type: ClientsActionTypes
  payload: ContractModel
}

export interface StoreClientContractAction {
  type: ClientsActionTypes
  payload: ContractModel
}

export interface StoreClientContractsAction {
  type: ClientsActionTypes
  payload: ContractModel[]
}
export interface StoreClientCommercialsAction {
  type: ClientsActionTypes
  payload: CommercialModel[]
}
export interface StoreContractProductsAction {
  type: ClientsActionTypes
  payload: ContractProductAPIModel[]
}

export interface StoreContractProductTempAction {
  type: ClientsActionTypes
  payload: NewContractProduct
}

export interface StoreRemoveContractProductTempAction {
  type: ClientsActionTypes
  payload: string | number
}

export interface StoreActiveContract {
  type: ClientsActionTypes
  payload: ContractModel
}

export interface StoreActiveTabAditionals {
  type: ClientsActionTypes
  payload: 'PRICE_COMPONENT' | 'FLEXIBILITY'
}

export interface ClearClientDataAction {
  type: ClientsActionTypes
}

export interface ClearClientContractsAction {
  type: ClientsActionTypes
}

export interface RemoveClientContractAction {
  type: ClientsActionTypes
  payload: number
}

export interface FetchingContractStart {
  type: ClientsActionTypes
}
export interface FetchingContractEnd {
  type: ClientsActionTypes
}
export interface FetchingClientStart {
  type: ClientsActionTypes
}
export interface FetchingClientEnd {
  type: ClientsActionTypes
}

export const switchOffCommunicationFromAdd = () => {
  return { type: ClientsActionTypes.SWITCH_COMM_CLIENT_ADD_OFF }
}

export const switchOffCommunicationFromFile = () => {
  return { type: ClientsActionTypes.SWITCH_COMM_CLIENT_FILE_OFF }
}

export const fetchingClientStartAction = () => {
  return { type: ClientsActionTypes.FETCH_CLIENT_START }
}

export const fetchingClientEndAction = () => {
  return { type: ClientsActionTypes.FETCH_CLIENT_END }
}

export const fetchingContractStartAction = () => {
  return { type: ClientsActionTypes.FETCH_CONTRACT_START }
}

export const fetchingContractEndAction = () => {
  return { type: ClientsActionTypes.FETCH_CONTRACT_END }
}

export const fetchingContractErrorAction = () => {
  return { type: ClientsActionTypes.FETCH_CONTRACT_ERROR }
}

export const fetchingContractsStartAction = () => {
  return { type: ClientsActionTypes.FETCH_CONTRACTS_START }
}

export const fetchingContractsEndAction = () => {
  return { type: ClientsActionTypes.FETCH_CONTRACTS_END }
}

export const fetchingContractsErrorAction = () => {
  return { type: ClientsActionTypes.FETCH_CONTRACTS_ERROR }
}

export const fetchingCommercialsStartAction = () => {
  return { type: ClientsActionTypes.FETCH_COMMERCIALS_START }
}

export const fetchingCommercialsEndAction = () => {
  return { type: ClientsActionTypes.FETCH_COMMERCIALS_END }
}

export const fetchingCommercialsErrorAction = () => {
  return { type: ClientsActionTypes.FETCH_COMMERCIALS_ERROR }
}

export const fetchingContractProductsStartAction = () => {
  return { type: ClientsActionTypes.FETCH_CONTRACT_PRODUCTS_START }
}

export const fetchingContractProductsEndAction = () => {
  return { type: ClientsActionTypes.FETCH_CONTRACT_PRODUCTS_END }
}

export const fetchingContractProductsErrorAction = () => {
  return { type: ClientsActionTypes.FETCH_CONTRACT_PRODUCTS_ERROR }
}

export const storeSearchTextAction = (searchText: string): StoreSearchTextAction => {
  return { type: ClientsActionTypes.STORE_SEARCH_TEXT, payload: searchText }
}

export const storeClientDataAction = (clientData: ClientFileModel): StoreClientDataAction => {
  return { type: ClientsActionTypes.STORE_CLIENT_DATA, payload: clientData }
}

export const storeClientDataErrorAction = () => {
  return { type: ClientsActionTypes.FETCH_CLIENT_ERROR }
}

export const storeClientContractAction = (contract: ContractModel): StoreClientContractAction => {
  return { type: ClientsActionTypes.STORE_CLIENT_CONTRACT, payload: contract }
}

export const storeUpdateClientContractAction = (
  contract: ContractModel
): StoreClientContractAction => {
  return { type: ClientsActionTypes.UPDATE_CLIENT_CONTRACT, payload: contract }
}

export const storeContractProductsAction = (
  products: ContractProductAPIModel[]
): StoreContractProductsAction => {
  return { type: ClientsActionTypes.STORE_CONTRACT_PRODUCTS, payload: products }
}

export const storeAddContractProductTempAction = (
  product: NewContractProduct
): StoreContractProductTempAction => {
  return { type: ClientsActionTypes.TEMP_ADD_CONTRACT_PRODUCT, payload: product }
}

export const storeUpdateContractProductTempAction = (
  product: NewContractProduct
): StoreContractProductTempAction => {
  return { type: ClientsActionTypes.TEMP_UPDATE_CONTRACT_PRODUCT, payload: product }
}

export const storeRemoveContractProductTempAction = (
  tempId: string | number
): StoreRemoveContractProductTempAction => {
  return { type: ClientsActionTypes.TEMP_REMOVE_CONTRACT_PRODUCT, payload: tempId }
}

export const storeClientContractsAction = (
  contract: ContractModel[]
): StoreClientContractsAction => {
  return { type: ClientsActionTypes.STORE_CLIENT_CONTRACTS, payload: contract }
}

export const storeClientCommercialsAction = (
  commercials: CommercialModel[]
): StoreClientCommercialsAction => {
  return { type: ClientsActionTypes.STORE_CLIENT_COMMERCIALS, payload: commercials }
}

export const setActiveContractAction = (contractId: number) => {
  return { type: ClientsActionTypes.SET_ACTIVE_CONTRACT, payload: contractId }
}

export const storeActiveContractAction = (contract: ContractModel | null) => {
  return { type: ClientsActionTypes.STORE_ACTIVE_CONTRACT, payload: contract }
}

export const storeActiveFlexibilityAction = (flexibility: FlexibilitiesModel | null) => {
  return { type: ClientsActionTypes.STORE_ACTIVE_FLEXIBILITY, payload: flexibility }
}

export const storeActiveTabAditionalsAction = (tab: 'PRICE_COMPONENTS' | 'FLEXIBILITY') => {
  return { type: ClientsActionTypes.ACTIVE_TAB_ADITIONALS, payload: tab }
}

export const clearActiveContractAction = () => {
  return { type: ClientsActionTypes.CLEAR_ACTIVE_CONTRACT }
}

export const clearActiveFlexibilityAction = () => {
  return { type: ClientsActionTypes.CLEAR_ACTIVE_FLEXIBILITY }
}

export const setDesactiveContractAction = () => {
  return { type: ClientsActionTypes.SET_DESACTIVE_CONTRACT }
}

export const clearClientDataAction = (): ClearClientDataAction => {
  return { type: ClientsActionTypes.CLEAR_CLIENT_DATA }
}

export const clearClientContractsAction = (): ClearClientContractsAction => {
  return { type: ClientsActionTypes.CLEAR_CLIENT_CONTRACTS }
}

export const clearClientCommercialsAction = (): ClearClientContractsAction => {
  return { type: ClientsActionTypes.CLEAR_CLIENT_COMMERCIALS }
}

export const removeClientContractAction = (contractID: number): RemoveClientContractAction => {
  return { type: ClientsActionTypes.REMOVE_CLIENT_CONTRACT, payload: contractID }
}

// Dependencies
// Countries
export const fetchingCountriesStartAction = () => {
  return { type: ClientsActionTypes.FETCH_COUNTRIES_START }
}

export const fetchingCountriesEndAction = () => {
  return { type: ClientsActionTypes.FETCH_COUNTRIES_END }
}

export const fetchingCountriesErrorAction = () => {
  return { type: ClientsActionTypes.FETCH_COUNTRIES_ERROR }
}

export const storeCountriesAction = (countries: SelectOption[]) => {
  return { type: ClientsActionTypes.STORE_COUNTRIES, payload: countries }
}

// Provinces
export const fetchingProvincesStartAction = () => {
  return { type: ClientsActionTypes.FETCH_PROVINCES_START }
}

export const fetchingProvincesEndAction = () => {
  return { type: ClientsActionTypes.FETCH_PROVINCES_END }
}

export const fetchingProvincesErrorAction = () => {
  return { type: ClientsActionTypes.FETCH_PROVINCES_ERROR }
}

export const storeProvincesAction = (Provinces: ProvinceModel[]) => {
  return { type: ClientsActionTypes.STORE_PROVINCES, payload: Provinces }
}

// Municipalities
export const fetchingMunicipalitiesStartAction = () => {
  return { type: ClientsActionTypes.FETCH_MUNICIPALITIES_START }
}

export const fetchingMunicipalitiesEndAction = () => {
  return { type: ClientsActionTypes.FETCH_MUNICIPALITIES_END }
}

export const fetchingMunicipalitiesErrorAction = () => {
  return { type: ClientsActionTypes.FETCH_MUNICIPALITIES_ERROR }
}

export const storeMunicipalitiesAction = (Municipalities: MunicipalityModel[]) => {
  return { type: ClientsActionTypes.STORE_MUNICIPALITIES, payload: Municipalities }
}

// Fetch all contracts by clientID and replace ALL contracts data.
export const fetchClientContractsAsync = (clientID: number) => {
  return dispatch => {
    const isFetching = store.getState().clientsState.isFetchingClientContracts
    if (isFetching) {
      return
    }

    dispatch(fetchingContractsStartAction())
    fetchContractsBySubjectID(clientID).then(response => {
      if (response.success && response.data) {
        dispatch(storeClientContractsAction(response.data))
      } else {
        dispatch(fetchingContractsErrorAction())
        notifyError(i18n.t('clientFile:actions.fetchClientContracts.error'))
      }
      dispatch(fetchingContractsEndAction())
    })
  }
}

// Fetch all contracts by clientID and replace ALL contracts data.
export const fetchClientCommercialsAsync = (clientID: number) => {
  return dispatch => {
    dispatch(fetchingCommercialsStartAction())
    fetchCommercialsBySubjectID(clientID).then(response => {
      if (response.success && response.data) {
        dispatch(storeClientCommercialsAction(response.data))
      } else {
        dispatch(fetchingCommercialsErrorAction())
        notifyError(i18n.t('clientFile:actions.fetchClientCommercials.error'))
      }
      dispatch(fetchingCommercialsEndAction())
    })
  }
}

// Fetch Contract and store as ActiveContract.
export const fetchContractAsync = (contractID: number) => {
  return dispatch => {
    dispatch(fetchingContractStartAction())
    fetchContractByID(contractID).then(response => {
      if (response.success && response.data) {
        dispatch(storeClientContractAction(response.data))
      } else {
        dispatch(fetchingContractErrorAction())
        notifyError(i18n.t('clientFile:actions.fetchClientContracts.error'))
      }
      dispatch(fetchingContractEndAction())
    })
  }
}

export const fetchContractProductsAsync = (contractID: number) => {
  return dispatch => {
    dispatch(fetchingContractProductsStartAction())
    fetchProductsByContractID(contractID).then(response => {
      if (response.success && response.data) {
        dispatch(storeContractProductsAction(response.data))
      } else {
        dispatch(fetchingContractProductsErrorAction())
        notifyError(i18n.t('contracts:notifications.fetchContractProducts.error'))
      }
      dispatch(fetchingContractProductsEndAction())
    })
  }
}

export const fetchClientDataAsync = (clientID: number) => {
  return dispatch => {
    dispatch(fetchingClientStartAction())
    fetchClient(clientID).then(response => {
      if (response.success && response.data) {
        dispatch(storeClientDataAction(clientDataMapper(response.data)))
      } else {
        dispatch(storeClientDataErrorAction())
        notifyError(i18n.t('clientFile:actions.fetchClientData.error'))
      }
      dispatch(fetchingClientEndAction())
    })
  }
}

export const fetchCountriesAsync = () => {
  return dispatch => {
    dispatch(fetchingCountriesStartAction())
    fetchCountries().then(response => {
      if (response.success && response.data) {
        dispatch(storeCountriesAction(response.data))
      } else {
        dispatch(fetchingCountriesErrorAction())
        notifyError(i18n.t('client:actions.fetchCountries.error'))
      }
      dispatch(fetchingCountriesEndAction())
    })
  }
}

export const fetchProvincesAsync = () => {
  return dispatch => {
    dispatch(fetchingProvincesStartAction())
    fetchProvinces().then(response => {
      if (response.success && response.data) {
        dispatch(storeProvincesAction(response.data))
      } else {
        dispatch(fetchingProvincesErrorAction())
        notifyError(i18n.t('client:actions.fetchProvinces.error'))
      }
      dispatch(fetchingProvincesEndAction())
    })
  }
}

export const fetchMunicipalitiesAsync = () => {
  return dispatch => {
    dispatch(fetchingMunicipalitiesStartAction())
    fetchMunicipalities().then(response => {
      if (response.success && response.data) {
        dispatch(storeMunicipalitiesAction(response.data))
      } else {
        dispatch(fetchingMunicipalitiesErrorAction())
        notifyError(i18n.t('client:actions.fetchMunicipalities.error'))
      }
      dispatch(fetchingMunicipalitiesEndAction())
    })
  }
}
